import React, { Suspense, useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'

import Header from 'components/Header/Header'
import Sidebar from 'components/Sidebar/Sidebar'
import Loader from 'components/Loader'

import { notificationsApi } from 'features/notifications/api/notificationsApi'
import { getFirebaseToken, subscribeForegroundMessages } from 'lib/firebase'
import { handleRequestError } from 'utils/handleRequestError'
import { getOrCreateDeviceId, getBrowserMetadata } from 'utils/deviceId'

const DefaultLayout = () => {
  const navigate = useNavigate()

  // Registers with the multi-device registry and the legacy single-token
  // endpoint in parallel, so admins.notification_token stays current while
  // the backend flag multi_device_notifications is off. Only a legacy
  // failure is surfaced.
  const StoreNotificationToken = async (token) => {
    const metadata = getBrowserMetadata()
    const [legacy, device] = await Promise.allSettled([
      notificationsApi.storeFcmToken(token),
      notificationsApi.registerDevice({
        deviceId: getOrCreateDeviceId(),
        fcmToken: token,
        platform: 'web',
        appType: 'web',
        deviceName: metadata.deviceName,
        deviceModel: metadata.deviceModel,
        osVersion: metadata.osVersion,
        permissionStatus:
          'Notification' in window ? Notification.permission : 'default',
      }),
    ])

    if (device.status === 'rejected') {
      console.warn('Admin device registration failed:', device.reason)
    }
    if (legacy.status === 'rejected') {
      handleRequestError(legacy.reason)
    }
  }

  const handleGetFirebaseToken = () => {
    getFirebaseToken()
      .then((firebaseToken) => {
        StoreNotificationToken(firebaseToken)
      })
      .catch((err) =>
        console.error(
          'An error occured while retrieving firebase token. ',
          err,
        ),
      )
  }

  useEffect(() => {
    handleGetFirebaseToken()
  }, [])

  useEffect(
    () => subscribeForegroundMessages(() => navigate('/notifications')),
    [navigate],
  )

  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className='dark:bg-boxdark-2 dark:text-bodydark'>
      <div className='flex h-screen overflow-hidden'>
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <div
          data-scroll-container='admin-main'
          className='relative flex flex-col flex-1 overflow-x-hidden overflow-y-auto bg-gray/5'
        >
          <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
          <main>
            <div className='p-5 mx-auto max-sm:p-4'>
              <Suspense fallback={<Loader />}>
                <Outlet />
              </Suspense>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default DefaultLayout
